import { FlashscanResult } from "@/types/Flashscan";
import apiClient from "./apiClient";

export type FlashscanJobStatus =
  | "PENDING"
  | "RUNNING"
  | "SUCCEEDED"
  | "FAILED"
  | "CANCELED";

export type FlashscanJobDto = {
  id: string;
  status: FlashscanJobStatus;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  resultFlashscanId: string | null;
  cachedHit: boolean;
  errorCode: string | null;
  errorMessage: string | null;
  notifyByEmail: boolean;
  emailSentAt: string | null;
  prepareMs: number | null;
  matchDecisionMs: number | null;
  persistMs: number | null;
  totalMs: number | null;
  salesCount: number | null;
  billsCount: number | null;
};

export const performFlashScan = async (input?: { notifyByEmail?: boolean }) => {
  return await apiClient.post<FlashscanJobDto>("flashscan/scan", input ?? {});
};

export const getLatestFlashscan = async () => {
  return await apiClient.get<FlashscanResult | null>("flashscan/latest");
};

export const getFlashscanJob = async (jobId: string) => {
  return await apiClient.get<FlashscanJobDto>(`flashscan/jobs/${jobId}`);
};

export const getActiveFlashscanJob = async () => {
  return await apiClient.get<FlashscanJobDto | null>("flashscan/jobs/active");
};

export const enableFlashscanJobEmailNotification = async (jobId: string) => {
  return await apiClient.post<FlashscanJobDto>(`flashscan/jobs/${jobId}/notify`);
};

export const cancelFlashscanJob = async (jobId: string) => {
  return await apiClient.post<FlashscanJobDto>(`flashscan/jobs/${jobId}/cancel`);
};

export const reconcileOrphanSale = async (saleId: string, billId: string) => {
  return await apiClient.post(`flashscan/orphan-sales/${saleId}/reconcile`, {
    billId,
  });
};

export const reconcileOrphanBill = async (billId: string, saleId: string) => {
  return await apiClient.post(`flashscan/orphan-bills/${billId}/reconcile`, {
    saleId,
  });
};
